module.exports = __webpack_public_path__ + "static/healthnx-hero-dede484b7f06b27660365ce7272f2272.jpg";